import React from 'react'
import { Tag } from 'antd'
import { SERVICE_PROVIDER_DETAILS } from "../../constants/serviceProviders"

const ServiceProviderTag = ({serviceProviderKey}) => {
  const serviceProvider = SERVICE_PROVIDER_DETAILS.find(serviceProvider => serviceProvider.key === serviceProviderKey)

  if (serviceProvider) {
    return <Tag color={serviceProvider.color}>{serviceProvider.name}</Tag>
  }

  return null
}

export default ServiceProviderTag